import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TokenGuard} from './shared/security/token.guard';
import {AutorizacaoAdminGuard} from './shared/security/autorizacao-admin.guard';
import {SuccessComponent} from './modules/success/success.component';


const routes: Routes = [
  { path: '', loadChildren: () => import('./modules/admin/admin.module')
      .then(m => m.AdminModule) , canActivate: [TokenGuard, AutorizacaoAdminGuard] },
  { path: 'master', loadChildren: () => import('./modules/master/master.module')
      .then(m => m.MasterModule), canActivate: [TokenGuard] },
  { path: 'login', loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule) },
  { path: 'register/:idPlan', loadChildren: () => import('./modules/register/register.module').then(m => m.RegisterModule) },
  { path: 'success/:empresaId', component: SuccessComponent },
  { path: 'user', loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule), canActivate: [TokenGuard] },
  { path: 'forgot-password', loadChildren: () => import('./modules/forgot/forgot.module').then(m => m.ForgotModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
